import { createGlobalStyle } from 'styled-components';
import { colors, otherColors } from './colors';
import { sizing } from './theme';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
    font-family: Inter;
  }

  a {
    color: ${otherColors.lxc.dark};
    text-decoration: underline;
  }

  li {
    list-style: none;
  }

  .scroll-snap {
    &-y { scroll-snap-type: y mandatory; }
    &-child { scroll-snap-align: start; }
  }

  .fs {
    &-14 { font-size: ${sizing.fontSize.sm}; }
    &-16 { font-size: ${sizing.fontSize.base}; }
    &-xxl { font-size: ${sizing.fontSize.xxl}; }
  }

  .font {
    &-inter { font-family: Inter };
    &-montserrat { font-family: Montserrat; }
  }

  .bg {
    &-lxc-dark { background-color: ${otherColors.lxc.dark}; }
    &-lxc-blue { background-color: ${otherColors.lxc.blue}; }
    &-lxc-red { background-color: ${otherColors.lxc.red}; }

    &-lxc-green-500 { background-color: ${colors.green.c500}; }
    &-lxc-green-400 { background-color: ${colors.green.c400}; }
    &-lxc-green-300 { background-color: ${colors.green.c300}; }
    &-lxc-green-200 { background-color: ${colors.green.c200}; }
    &-lxc-green-100 { background-color: ${colors.green.c100}; }
    &-lxc-green-50 { background-color: ${colors.green.c50}; }

    &-lxc-orange-500 { background-color: ${colors.orange.c500}; }
    &-lxc-orange-400 { background-color: ${colors.orange.c400}; }
    &-lxc-orange-300 { background-color: ${colors.orange.c300}; }
    &-lxc-orange-200 { background-color: ${colors.orange.c200}; }
    &-lxc-orange-100 { background-color: ${colors.orange.c100}; }
    &-lxc-orange-50 { background-color: ${colors.orange.c50}; }

    &-lxc-purple-500 { background-color: ${colors.purple.c500}; }
    &-lxc-purple-400 { background-color: ${colors.purple.c400}; }
    &-lxc-purple-300 { background-color: ${colors.purple.c300}; }
    &-lxc-purple-200 { background-color: ${colors.purple.c200}; }
    &-lxc-purple-100 { background-color: ${colors.purple.c100}; }
    &-lxc-purple-50 { background-color: ${colors.purple.c50}; }

    &-lxc-blue-500 { background-color: ${colors.blue.c500}; }
    &-lxc-blue-400 { background-color: ${colors.blue.c400}; }
    &-lxc-blue-300 { background-color: ${colors.blue.c300}; }
    &-lxc-blue-200 { background-color: ${colors.blue.c200}; }
    &-lxc-blue-100 { background-color: ${colors.blue.c100}; }
    &-lxc-blue-50 { background-color: ${colors.blue.c50}; }

    &-lxc-pink-500 { background-color: ${colors.pink.c500}; }
    &-lxc-pink-400 { background-color: ${colors.pink.c400}; }
    &-lxc-pink-300 { background-color: ${colors.pink.c300}; }
    &-lxc-pink-200 { background-color: ${colors.pink.c200}; }
    &-lxc-pink-100 { background-color: ${colors.pink.c100}; }
    &-lxc-pink-50 { background-color: ${colors.pink.c50}; }

    &-lxc-gold-500 { background-color: ${colors.gold.c500}; }
    &-lxc-gold-400 { background-color: ${colors.gold.c400}; }
    &-lxc-gold-300 { background-color: ${colors.gold.c300}; }
    &-lxc-gold-200 { background-color: ${colors.gold.c200}; }
    &-lxc-gold-100 { background-color: ${colors.gold.c100}; }
    &-lxc-gold-50 { background-color: ${colors.gold.c50}; }

    &-lxc-silver-500 { background-color: ${colors.silver.c500}; }
    &-lxc-silver-400 { background-color: ${colors.silver.c400}; }
    &-lxc-silver-300 { background-color: ${colors.silver.c300}; }
    &-lxc-silver-200 { background-color: ${colors.silver.c200}; }
    &-lxc-silver-100 { background-color: ${colors.silver.c100}; }
    &-lxc-silver-50 { background-color: ${colors.silver.c50}; }

    &-lxc-teal-500 { background-color: ${colors.teal.c500}; }
    &-lxc-teal-400 { background-color: ${colors.teal.c400}; }
    &-lxc-teal-300 { background-color: ${colors.teal.c300}; }
    &-lxc-teal-200 { background-color: ${colors.teal.c200}; }
    &-lxc-teal-100 { background-color: ${colors.teal.c100}; }
    &-lxc-teal-50 { background-color: ${colors.teal.c50}; }

    &-lxc-yellow-500 { background-color: ${colors.yellow.c500}; }
    &-lxc-yellow-400 { background-color: ${colors.yellow.c400}; }
    &-lxc-yellow-300 { background-color: ${colors.yellow.c300}; }
    &-lxc-yellow-200 { background-color: ${colors.yellow.c200}; }
    &-lxc-yellow-100 { background-color: ${colors.yellow.c100}; }
    &-lxc-yellow-50 { background-color: ${colors.yellow.c50}; }

    &-lxc-cyan-500 { background-color: ${colors.cyan.c500}; }
    &-lxc-cyan-400 { background-color: ${colors.cyan.c400}; }
    &-lxc-cyan-300 { background-color: ${colors.cyan.c300}; }
    &-lxc-cyan-200 { background-color: ${colors.cyan.c200}; }
    &-lxc-cyan-100 { background-color: ${colors.cyan.c100}; }
    &-lxc-cyan-50 { background-color: ${colors.cyan.c50}; }

    &-lxc-indigo-500 { background-color: ${colors.indigo.c500}; }
    &-lxc-indigo-400 { background-color: ${colors.indigo.c400}; }
    &-lxc-indigo-300 { background-color: ${colors.indigo.c300}; }
    &-lxc-indigo-200 { background-color: ${colors.indigo.c200}; }
    &-lxc-indigo-100 { background-color: ${colors.indigo.c100}; }
    &-lxc-indigo-50 { background-color: ${colors.indigo.c50}; }
  }

  .border {
    &-lxc-dark { border-color: ${otherColors.lxc.dark} !important; }
    &-lxc-blue { border-color: ${otherColors.lxc.blue} !important; }
    &-lxc-gray { border-color: ${otherColors.border.gray} !important; }
    &-lxc-red { border-color: ${otherColors.lxc.red} !important; }

    &-lxc-green-500 { border-color: ${colors.green.c500} !important; }
    &-lxc-green-400 { border-color: ${colors.green.c400} !important; }
    &-lxc-green-300 { border-color: ${colors.green.c300} !important; }
    &-lxc-green-200 { border-color: ${colors.green.c200} !important; }
    &-lxc-green-100 { border-color: ${colors.green.c100} !important; }
    &-lxc-green-50 { border-color: ${colors.green.c50} !important; }

    &-lxc-orange-500 { border-color: ${colors.orange.c500} !important; }
    &-lxc-orange-400 { border-color: ${colors.orange.c400} !important; }
    &-lxc-orange-300 { border-color: ${colors.orange.c300} !important; }
    &-lxc-orange-200 { border-color: ${colors.orange.c200} !important; }
    &-lxc-orange-100 { border-color: ${colors.orange.c100} !important; }
    &-lxc-orange-50 { border-color: ${colors.orange.c50} !important; }

    &-lxc-purple-500 { border-color: ${colors.purple.c500} !important; }
    &-lxc-purple-400 { border-color: ${colors.purple.c400} !important; }
    &-lxc-purple-300 { border-color: ${colors.purple.c300} !important; }
    &-lxc-purple-200 { border-color: ${colors.purple.c200} !important; }
    &-lxc-purple-100 { border-color: ${colors.purple.c100} !important; }
    &-lxc-purple-50 { border-color: ${colors.purple.c50} !important; }

    &-lxc-blue-500 { border-color: ${colors.blue.c500} !important; }
    &-lxc-blue-400 { border-color: ${colors.blue.c400} !important; }
    &-lxc-blue-300 { border-color: ${colors.blue.c300} !important; }
    &-lxc-blue-200 { border-color: ${colors.blue.c200} !important; }
    &-lxc-blue-100 { border-color: ${colors.blue.c100} !important; }
    &-lxc-blue-50 { border-color: ${colors.blue.c50} !important; }

    &-lxc-pink-500 { border-color: ${colors.pink.c500} !important; }
    &-lxc-pink-400 { border-color: ${colors.pink.c400} !important; }
    &-lxc-pink-300 { border-color: ${colors.pink.c300} !important; }
    &-lxc-pink-200 { border-color: ${colors.pink.c200} !important; }
    &-lxc-pink-100 { border-color: ${colors.pink.c100} !important; }
    &-lxc-pink-50 { border-color: ${colors.pink.c50} !important; }

    &-lxc-gold-500 { border-color: ${colors.gold.c500} !important; }
    &-lxc-gold-400 { border-color: ${colors.gold.c400} !important; }
    &-lxc-gold-300 { border-color: ${colors.gold.c300} !important; }
    &-lxc-gold-200 { border-color: ${colors.gold.c200} !important; }
    &-lxc-gold-100 { border-color: ${colors.gold.c100} !important; }
    &-lxc-gold-50 { border-color: ${colors.gold.c50} !important; }

    &-lxc-silver-500 { border-color: ${colors.silver.c500} !important; }
    &-lxc-silver-400 { border-color: ${colors.silver.c400} !important; }
    &-lxc-silver-300 { border-color: ${colors.silver.c300} !important; }
    &-lxc-silver-200 { border-color: ${colors.silver.c200} !important; }
    &-lxc-silver-100 { border-color: ${colors.silver.c100} !important; }
    &-lxc-silver-50 { border-color: ${colors.silver.c50} !important; }

    &-lxc-teal-500 { border-color: ${colors.teal.c500} !important; }
    &-lxc-teal-400 { border-color: ${colors.teal.c400} !important; }
    &-lxc-teal-300 { border-color: ${colors.teal.c300} !important; }
    &-lxc-teal-200 { border-color: ${colors.teal.c200} !important; }
    &-lxc-teal-100 { border-color: ${colors.teal.c100} !important; }
    &-lxc-teal-50 { border-color: ${colors.teal.c50} !important; }

    &-lxc-yellow-500 { border-color: ${colors.yellow.c500} !important; }
    &-lxc-yellow-400 { border-color: ${colors.yellow.c400} !important; }
    &-lxc-yellow-300 { border-color: ${colors.yellow.c300} !important; }
    &-lxc-yellow-200 { border-color: ${colors.yellow.c200} !important; }
    &-lxc-yellow-100 { border-color: ${colors.yellow.c100} !important; }
    &-lxc-yellow-50 { border-color: ${colors.yellow.c50} !important; }

    &-lxc-cyan-500 { border-color: ${colors.cyan.c500} !important; }
    &-lxc-cyan-400 { border-color: ${colors.cyan.c400} !important; }
    &-lxc-cyan-300 { border-color: ${colors.cyan.c300} !important; }
    &-lxc-cyan-200 { border-color: ${colors.cyan.c200} !important; }
    &-lxc-cyan-100 { border-color: ${colors.cyan.c100} !important; }
    &-lxc-cyan-50 { border-color: ${colors.cyan.c50} !important; }

    &-lxc-indigo-500 { border-color: ${colors.indigo.c500} !important; }
    &-lxc-indigo-400 { border-color: ${colors.indigo.c400} !important; }
    &-lxc-indigo-300 { border-color: ${colors.indigo.c300} !important; }
    &-lxc-indigo-200 { border-color: ${colors.indigo.c200} !important; }
    &-lxc-indigo-100 { border-color: ${colors.indigo.c100} !important; }
    &-lxc-indigo-50 { border-color: ${colors.indigo.c50} !important; }
  }

  .text {
    &-lxc-dark { color: ${otherColors.lxc.dark} !important; }
    &-lxc-blue { color: ${otherColors.lxc.blue} !important; }
    &-lxc-gray { color: ${otherColors.gray} !important; }
    &-lxc-red { border-color: ${otherColors.lxc.red} !important; }

    &-lxc-green-500 { color: ${colors.green.c500} !important; }
    &-lxc-green-400 { color: ${colors.green.c400} !important; }
    &-lxc-green-300 { color: ${colors.green.c300} !important; }
    &-lxc-green-200 { color: ${colors.green.c200} !important; }
    &-lxc-green-100 { color: ${colors.green.c100} !important; }
    &-lxc-green-50 { color: ${colors.green.c50} !important; }

    &-lxc-orange-500 { color: ${colors.orange.c500} !important; }
    &-lxc-orange-400 { color: ${colors.orange.c400} !important; }
    &-lxc-orange-300 { color: ${colors.orange.c300} !important; }
    &-lxc-orange-200 { color: ${colors.orange.c200} !important; }
    &-lxc-orange-100 { color: ${colors.orange.c100} !important; }
    &-lxc-orange-50 { color: ${colors.orange.c50} !important; }

    &-lxc-purple-500 { color: ${colors.purple.c500} !important; }
    &-lxc-purple-400 { color: ${colors.purple.c400} !important; }
    &-lxc-purple-300 { color: ${colors.purple.c300} !important; }
    &-lxc-purple-200 { color: ${colors.purple.c200} !important; }
    &-lxc-purple-100 { color: ${colors.purple.c100} !important; }
    &-lxc-purple-50 { color: ${colors.purple.c50} !important; }

    &-lxc-blue-500 { color: ${colors.blue.c500} !important; }
    &-lxc-blue-400 { color: ${colors.blue.c400} !important; }
    &-lxc-blue-300 { color: ${colors.blue.c300} !important; }
    &-lxc-blue-200 { color: ${colors.blue.c200} !important; }
    &-lxc-blue-100 { color: ${colors.blue.c100} !important; }
    &-lxc-blue-50 { color: ${colors.blue.c50} !important; }

    &-lxc-pink-500 { color: ${colors.pink.c500} !important; }
    &-lxc-pink-400 { color: ${colors.pink.c400} !important; }
    &-lxc-pink-300 { color: ${colors.pink.c300} !important; }
    &-lxc-pink-200 { color: ${colors.pink.c200} !important; }
    &-lxc-pink-100 { color: ${colors.pink.c100} !important; }
    &-lxc-pink-50 { color: ${colors.pink.c50} !important; }

    &-lxc-gold-500 { color: ${colors.gold.c500} !important; }
    &-lxc-gold-400 { color: ${colors.gold.c400} !important; }
    &-lxc-gold-300 { color: ${colors.gold.c300} !important; }
    &-lxc-gold-200 { color: ${colors.gold.c200} !important; }
    &-lxc-gold-100 { color: ${colors.gold.c100} !important; }
    &-lxc-gold-50 { color: ${colors.gold.c50} !important; }

    &-lxc-silver-500 { color: ${colors.silver.c500} !important; }
    &-lxc-silver-400 { color: ${colors.silver.c400} !important; }
    &-lxc-silver-300 { color: ${colors.silver.c300} !important; }
    &-lxc-silver-200 { color: ${colors.silver.c200} !important; }
    &-lxc-silver-100 { color: ${colors.silver.c100} !important; }
    &-lxc-silver-50 { color: ${colors.silver.c50} !important; }

    &-lxc-teal-500 { color: ${colors.teal.c500} !important; }
    &-lxc-teal-400 { color: ${colors.teal.c400} !important; }
    &-lxc-teal-300 { color: ${colors.teal.c300} !important; }
    &-lxc-teal-200 { color: ${colors.teal.c200} !important; }
    &-lxc-teal-100 { color: ${colors.teal.c100} !important; }
    &-lxc-teal-50 { color: ${colors.teal.c50} !important; }

    &-lxc-yellow-500 { color: ${colors.yellow.c500} !important; }
    &-lxc-yellow-400 { color: ${colors.yellow.c400} !important; }
    &-lxc-yellow-300 { color: ${colors.yellow.c300} !important; }
    &-lxc-yellow-200 { color: ${colors.yellow.c200} !important; }
    &-lxc-yellow-100 { color: ${colors.yellow.c100} !important; }
    &-lxc-yellow-50 { color: ${colors.yellow.c50} !important; }

    &-lxc-cyan-500 { color: ${colors.cyan.c500} !important; }
    &-lxc-cyan-400 { color: ${colors.cyan.c400} !important; }
    &-lxc-cyan-300 { color: ${colors.cyan.c300} !important; }
    &-lxc-cyan-200 { color: ${colors.cyan.c200} !important; }
    &-lxc-cyan-100 { color: ${colors.cyan.c100} !important; }
    &-lxc-cyan-50 { color: ${colors.cyan.c50} !important; }

    &-lxc-indigo-500 { color: ${colors.indigo.c500} !important; }
    &-lxc-indigo-400 { color: ${colors.indigo.c400} !important; }
    &-lxc-indigo-300 { color: ${colors.indigo.c300} !important; }
    &-lxc-indigo-200 { color: ${colors.indigo.c200} !important; }
    &-lxc-indigo-100 { color: ${colors.indigo.c100} !important; }
    &-lxc-indigo-50 { color: ${colors.indigo.c50} !important; }
  }

  .button-h {
    &-50 { height: 50px; }
  }

  .text-sm {
    font-size: 0.8rem;
  }

  .modal-content-sm {
    width: 412px;
  }
  
  .custom-toast .Toastify__progress-bar {
    background-color: #D1FAE5;
  }

  .react-placeholder.rect-shape {
    width: calc(100% - 2px) !important;
    border-radius: 8px;
    margin-left: 1px;
    background-color: #dae5eb !important;
  }

  .react-resizable-handle {
    --size: 6px;

    width: var(--size);
    height: var(--size);
    background-image: none;
    background-color: #fff;
    border: 2px solid ${otherColors.lxc.blue};
    border-radius: 50%;
    margin: 0;
    padding: 0;

    &.react-resizable-handle-n {
      transform: translate3d(calc(var(--size) / -2), -2px, 0);
    }
    &.react-resizable-handle-s {
      transform: translate3d(calc(var(--size) / -2), 2px, 0);
    }
    &.react-resizable-handle-w {
      transform: translate3d(-2px, calc(var(--size) / -2), 0);
    }
    &.react-resizable-handle-e {
      transform: translate3d(2px, calc(var(--size) / -2), 0);
    }
  }

  .drift-conductor-item:not(.drift-chat-open) {
    z-index: -1 !important;
  }
`;

export { GlobalStyle };
